import React from 'react';
import { makeStyles } from '@mui/styles';
import { Fade } from 'react-awesome-reveal';
import { Link } from 'react-router-dom'
import { HiArrowRight } from "react-icons/hi";

import placeholder from '../../../assets/png/placeholder.png';
import './SingleProject.css';

function SingleProject({ id, name, desc, tags, code, url, image, theme,button,index,origin,title }) {
    const useStyles = makeStyles((t) => ({
        iconBtn: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 40,
            height: 40,
            borderRadius: 50,
            border: `2px solid ${theme.secondary}`,
            color: theme.secondary,
            transition: 'all 0.2s',
            '&:hover': {
                backgroundColor: theme.secondary,
                color: theme.primary,
                transform: 'scale(1.1)',
                border: `2px solid ${theme.primary}`,
            },
        },
        icon: {
            fontSize: '1.1rem',
            transition: 'all 0.2s',
            '&:hover': {},
        },
        viewAllBtn : {
            backgroundColor: theme.primary,
            // color: theme.secondary,
            borderRadius: '0px',
            textTransform: 'inherit',
            textDecoration: 'none',
            width: '150px',
            height: '50px',
            fontSize: '1rem',
            fontWeight: '500',
            fontFamily: 'var(--primaryFont)',
            border: `1px solid ${theme.fourthly}`,
            transition: 'color 0.5s',
            '&:hover': {
                transform: 'scale(1.05)',
                backgroundColor: theme.tertiary,
                color: theme.primary,
                border: `1px solid ${theme.tertiary}`,
            },
            [t.breakpoints.down('sm')]: {
                display: 'block',
            },
        },
        viewArr : {
            color: theme.secondary, 
            // backgroundColor: theme.secondary70,
            width: '40px',
            height: '40px',
            padding: '0.5rem',
            fontSize: '1.05rem',
            borderRadius: '50%',
            cursor: 'pointer',
            transition: 'background-color 0.2s',
            "&:hover": {
                color: theme.tertiary, 
                backgroundColor: theme.secondary,
            }
        },
    }));

    const classes = useStyles();

    if (name === 'empty') {
        if(button==='none') {
            if (index ==='1') {
                return (<div className={origin ==='home' ? 'emptyProject' : 'emptyProject allBorder'}>
                        <div className="portfolio">
                            <h4>{title ==='none' ? '' : 'Portfolio'}</h4>
                        </div>
                    </div>);
            } else {
                return <div className={origin ==='home' ? 'emptyProject' : 'emptyProject allBorder'}></div>;
            }
        } else {
            if (index ==='1'){
                return (<div className={origin ==='home' ? 'emptyProject' : 'emptyProject allBorder'}>
                    <div className="projects--viewAll">
                        <Link to="/portfolio">
                            <button className={classes.viewAllBtn}>
                                Voir plus
                                <HiArrowRight className={classes.viewArr} />
                            </button>
                        </Link>
                    </div>
                </div>
                );
            } else {
                return <div className={origin ==='home' ? 'emptyProject' : 'emptyProject allBorder'}></div>;
            }
        }
    }
    return (
        <Fade direction="up" triggerOnce style={{ minHeight: '460px' }}>
            <a href={url} target="_blank" rel="noreferrer">
                <div
                    className={origin ==='home' ? 'singleProject' : 'singleProject allBorder'}
                    style={{ backgroundColor: 'transparent' }}
                >
                    <div className='projectContent'>
                        <img src={image ? image : placeholder} alt={name} />
                        <h5
                            id={name.replace(' ', '-').toLowerCase()}
                            style={{ color: theme.secondary }}
                        >
                            {name}
                        </h5>
                        <p
                            className='project--desc'>
                            {desc}
                        </p>
                    </div>
                </div>
            </a>
        </Fade>
    );
}

export default SingleProject;
